export default "/_next/static/images/bc/searchMobile-bc25d359d55bd4c43b5a19f4719161a5.jpg";